export default [{
  path: '/company-profile',
  name: 'companyprofile',
  component: () => import('@/app/company-profile/CompanyProfile'),
  meta: {
    resource: 'companyprofile',
    actions: ['read']
  }
}]
